import React from "react";
import Background from "../Background";
import UserTable from "./UserTable";

const UserManagement = () => {
    return (
        <Background heading={"User Management"} key="user-management">
            <UserTable length={30} />
        </Background>
    );
};

export default UserManagement;
